import axios from 'axios';
import { put, call } from 'redux-saga/effects';

// CONSTANTS
import {
  SR_USERS_GET_DETAILS,
  SR_USERS_GET_PAYMENTS,
  SR_USERS_SEND_TRANSFER_REQUEST,
} from '@/constants/api';

// UTILITY
import { showErrorNotification } from '@/utility/saga';
import { getLink } from '@/utility/routes';

// STORE
import { SRUsersActions } from '@/store/actions';
import { pushSuccessNotification } from '@/utility/snackbar';
import { t } from '@/locale/i18n';
// import * as endpoints from '@/constants/api';

const { getSRUserDetails, getSRUserPayments, sendSRUserTransferRequest } = SRUsersActions;

export function* getSRUserDetailsSaga(action) {
  yield put({ type: getSRUserDetails.types.START });

  const { user_id } = action.payload;
  const url = getLink(SR_USERS_GET_DETAILS, { user_id });

  try {
    const { data: respData } = yield axios.get(url);

    yield put({
      type: getSRUserDetails.types.SUCCESS,
      payload: {
        data: respData.data,
      },
    });
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: getSRUserDetails.types.FAIL,
    });
  }
}

export function* getSRUserPaymentsSaga(action) {
  yield put({ type: getSRUserPayments.types.START });

  const { user_id, params } = action.payload;
  const url = getLink(SR_USERS_GET_PAYMENTS, { user_id });

  try {
    const { data: respData } = yield axios.get(url, { params });

    yield put({
      type: getSRUserPayments.types.SUCCESS,
      payload: {
        data: respData.data,
        meta: respData.meta,
      },
    });
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: getSRUserPayments.types.FAIL,
    });
  }
}

export function* sendSRUserTransferRequestSaga(action) {
  yield put({ type: sendSRUserTransferRequest.types.START });

  const { user_id, params } = action.payload;
  const url = getLink(SR_USERS_SEND_TRANSFER_REQUEST, { user_id });

  try {
    const { data: respData } = yield axios.post(url, params);

    yield put({
      type: sendSRUserTransferRequest.types.SUCCESS,
      payload: {
        streaming_reward_id: params.streaming_reward_id,
        transfer_request: respData.request,
      },
    });

    pushSuccessNotification(respData.message || t('notification.transferRequestSentSuccess'));
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: sendSRUserTransferRequest.types.FAIL,
    });
  }
}
